<template>
	<div v-if="isUserAllowedInLevel2 && isAuthenticatedUserInGroupAdmin">
		<div>
			<BaseHeader v-if="isForOnboarding === false" :title="getTitle">
				<BaseButton class="btn-default" @click="fetchDefault" v-if="$store.getters.getUser.person.company.id !== getL2AdminID()">
					<font-awesome-icon :icon="['fas', 'undo-alt']" class="mr-4"></font-awesome-icon>{{ 'Alles zurücksetzen' }}
				</BaseButton>
			</BaseHeader>
			<div class="main">
				<div v-if="pdfTemplate" class="w-full flex">
					<div class="w-1/2 pr-20">
						<div class="flex gap-4 mb-6">
							<!--							<BaseSelect-->
							<!--								class="self-center min-w-40"-->
							<!--								:selected-label="null"-->
							<!--								ref="BaseSelect.FontSize"-->
							<!--								:options="pageOptions"-->
							<!--								:label="$t('page')"-->
							<!--								v-model="selectedPageOption"-->
							<!--							/>-->
							<BaseSelect
								class="self-center min-w-40"
								:selected-label="null"
								ref="BaseSelect.FontSize"
								:options="textBlockOptions"
								:label="$t('text_block')"
								@input="setTextBoxContent"
								v-model="selectedTextBlockOption"
							/>
						</div>
						<div class="border-2 border-connectProBlue w-full rounded mb-4 px-4 py-2 flex gap-4 justify-start" style="align-items: center">
							<!--							<BaseSelect-->
							<!--								class="self-center max-h-6"-->
							<!--								:selected-label="null"-->
							<!--								ref="BaseSelect.FontSize"-->
							<!--								:options="fontSizeOptions"-->
							<!--								v-model="selectedFontSize"-->
							<!--								@change="applyFontSize"-->
							<!--							/>-->
							<!-- bold -->
							<div
								class="border-2 border-connectProBlue bg-white rounded-full w-10 h-10 cursor-pointer"
								:class="isBold ? 'bg-connectProBlue' : 'bg-white'"
								@mousedown.prevent="onBold"
							>
								<div class="font-bold text-center pt-1" :class="isBold ? 'text-white' : 'text-black'">b</div>
							</div>
							<!-- italic -->
							<div
								class="border-2 border-connectProBlue bg-white rounded-full w-10 h-10 cursor-pointer"
								:class="isItalic ? 'bg-connectProBlue' : 'bg-white'"
								@mousedown.prevent="onItalic"
							>
								<div class="italic text-center pt-1" :class="isItalic ? 'text-white' : 'text-black'">i</div>
							</div>
							<!-- underline -->
							<div
								class="border-2 border-connectProBlue bg-white rounded-full w-10 h-10 cursor-pointer"
								:class="isUnderlined ? 'bg-connectProBlue' : 'bg-white'"
								@mousedown.prevent="onUnderline"
							>
								<div class="text-center pt-1 underline" :class="isUnderlined ? 'text-white' : 'text-black'">u</div>
							</div>
						</div>
						<div
							ref="editorBox"
							class="scroll-container w-full border border-gray-300 rounded h-80 overflow-y-auto focus-within:ring-2 focus-within:ring-blue-300"
							@mousedown.self.prevent="focusEnd"
							@click.self.prevent="focusEnd"
						>
							<editor-content v-if="editor" :editor="editor" class="editor-surface" style="text-align: left" />
						</div>
					</div>
					<div class="w-1/2 border-l-2 border-connectProBlue pl-10" v-if="isPDFLoading === false">
						<PDFThumbnailPreview
							:pdf-u-r-l="pdfURL"
							class="cursor-pointer"
							:class="isForOnboarding ? 'w-8/12' : 'w-10/12'"
							:uuid="uuid"
							show-route-params="true"
							:type="PDFTypes.DamageAccessor"
							:iframe-height="isForOnboarding ? '600px' : '870px'"
						/>
<!--						<div class="flex justify-center pt-10">-->
<!--							<div>-->
<!--								<font-awesome-icon :icon="['fas', 'chevron-left']" />-->
<!--							</div>-->
<!--							<div class="ml-10 mr-10 font-bold">-->
<!--								{{ $t('page_number', { number: 1 }) }}-->
<!--							</div>-->
<!--							<div>-->
<!--								<font-awesome-icon :icon="['fas', 'chevron-right']" />-->
<!--							</div>-->
<!--						</div>-->
					</div>
					<div class="w-1/2 border-l-2 border-connectProBlue pl-10" v-else>
						<LoadingSpinner />
					</div>
				</div>
				<div v-else class="flex flex-grow justify-center w-full opacity-75">
					<LoadingSpinner />
				</div>
			</div>
			<Footer v-if="isForOnboarding === false" class="mx-8" :is-back-button="true" @backButtonClick="$router.go(-1)">
				<template #continueButton>
					<SaveButton @click="save" class="w-16 btn-blue">
						{{ $t('general.save') }}
					</SaveButton>
				</template>
			</Footer>
		</div>
	</div>
	<Forbidden v-else />
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader.vue';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Forbidden from '@/views/default/Forbidden.vue';
import Authentication from '@/mixins/Authentication';
import AppContainerMixin from '@/mixins/AppContainerMixin';
import Footer from '@/components/damagecases/Footer.vue';
import SaveButton from '@/components/forms/buttons/SaveButton.vue';
import BaseTextarea from '@/components/forms/inputs/BaseTextarea.vue';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import PDFThumbnailPreview from '@/components/damagecases/forms/PDFThumbnailPreview.vue';
import { PdfApiFactory, PDFTypes } from '@/api/generated';
import EditorEngine from '@/utils/EditorEngine';
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import PDFBlueprintRepository from '@/api/repositories/PDFBlueprintRepository';

import { Editor, EditorContent } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import TextStyle from '@tiptap/extension-text-style';
import apiDefaults from '@/api/defaultConfiguration';
import { getL2AdminID } from '@/helpers/Utils';

export default {
	name: 'PDFBlueprintsEdit',
	components: { BaseButton, PDFThumbnailPreview, BaseSelect, BaseTextarea, SaveButton, Footer, Forbidden, LoadingSpinner, BaseHeader, EditorContent },
	mixins: [Authentication, AppContainerMixin],
	props: {
		isForOnboarding: { default: false, required: false },
		templateIDParam: { required: false },
	},
	data() {
		return {
			engine: null,
			editor: null,
			pdfTemplate: null,
			pdfBlueprintValues: null,
			textFieldContent: '',
			fontSizeOptions: [
				{
					display: 8,
					value: 8,
				},
				{
					display: 9,
					value: 9,
				},
				{
					display: 10,
					value: 10,
				},
				{
					display: 11,
					value: 11,
				},
				{
					display: 12,
					value: 12,
				},
				{
					display: 13,
					value: 13,
				},
				{
					display: 14,
					value: 14,
				},
				{
					display: 15,
					value: 16,
				},
				{
					display: 16,
					value: 16,
				},
				{
					display: 17,
					value: 17,
				},
				{
					display: 18,
					value: 18,
				},
				{
					display: 19,
					value: 19,
				},
				{
					display: 20,
					value: 20,
				},
			],
			selectedFontSize: null,
			pageOptions: [
				{
					display: 'Seite 1',
					value: 1,
				},
				{
					display: 'Seite 2',
					value: 2,
				},
			],
			selectedPageOption: null,
			textBlockOptions: [],
			selectedTextBlockOption: null,
			isBold: false,
			isItalic: false,
			isUnderlined: false,
			uuid: '',
			pdfURL: '',
			isLoading: false,
			textfieldTimeoutID: null,
			isDoneInitializing: false,
			isPDFLoading: false,
			templateID: null,
		};
	},
	computed: {
		PDFTypes() {
			return PDFTypes;
		},
		getTitle() {
			return this.pdfTemplate != null ? this.pdfTemplate.label + ' ' + this.$t('edit_low') : '';
		},
	},
	mounted() {
		this.selectedFontSize = this.fontSizeOptions[0];
		this.selectedPageOption = this.pageOptions[0];
		if (this.isForOnboarding) {
			this.templateID = this.templateIDParam;
		} else {
			this.templateID = this.$route.params.id;
		}
		this.fetchPDFTemplateById();
		this.initEditor();
	},
	watch: {
		textFieldContent(newHtml) {
			if (this.editor && newHtml !== this.editor.getHTML()) {
				this.editor.commands.setContent(newHtml || '', false);
			}
		},
		isDoneInitializing(newVal, oldVal) {
			if (oldVal == false && newVal) {
				this.getPDF();
			}
		},
	},
	beforeDestroy() {
		this.editor?.destroy();
	},
	methods: {
		getL2AdminID,
		initEditor() {
			this.editor = new Editor({
				content: this.textFieldContent,
				extensions: [
					StarterKit.configure({
						heading: false,
						code: false,
						strike: false,
						blockquote: false,
					}),
					TextStyle,
				],
				onUpdate: () => {
					this.textFieldContent = this.editor.getHTML();
					clearTimeout(this.textfieldTimeoutID);
					this.textfieldTimeoutID = setTimeout(() => {
						if (!this.selectedTextBlockOption || !this.pdfBlueprintValues) return;
						const rec = this.pdfBlueprintValues.find(el => el.id === this.selectedTextBlockOption.value);
						if (rec) rec.value = this.textFieldContent;
						if (this.isDoneInitializing) {
							this.getPDF();
							this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
						}
					}, 1000);
				},
				onSeletionUpdate() {
					this.isBold = this.editor.isActive('bold');
					this.isItalic = this.editor.isActive('italic');
					this.isUnderlined = this.editor.isActive('underline');
				},
				editorProps: {
					handlePaste: (view, event) => {
						const text = event.clipboardData?.getData('text/plain');
						if (text != null) {
							event.preventDefault();
							this.editor.commands.insertContent(text);
							return true;
						}
						return false;
					},
				},
			});
		},
		changeBoldStatus() {
			this.isBold = !this.isBold;
		},
		changeItalicStatus() {
			this.isItalic = !this.isItalic;
		},
		changeUnderlineStatus() {
			this.isUnderlined = !this.isUnderlined;
		},
		fetchPDFTemplateById() {
			if (this.$store.getters.getUser.person.company.id === getL2AdminID()) {
				new PDFBlueprintRepository()
					.getBlueprintSampleValues(this.templateID)
					.then(response => {
						this.pdfTemplate = { id: response.data.id, label: response.data.label };
						this.pdfBlueprintValues = response.data.values;
						this.textFieldContent = response.data.values[0].value;
						this.textBlockOptions = response.data.values.map((element, index) => {
							return { display: element.label ? element.label : 'Textblock ' + (index + 1), value: element.id };
						});
						this.selectedTextBlockOption = this.textBlockOptions[0];
						this.isDoneInitializing = true;
					})
					.catch(e => {
						console.log(e);
						this.$swal(this.$t('general.error').toString(), this.$t('values_cannot_be_fetched').toString(), 'error');
					});
			} else {
				new PDFBlueprintRepository()
					.getBlueprintValuesByID(this.templateID)
					.then(response => {
						this.pdfTemplate = { id: response.data.id, label: response.data.label };
						this.pdfBlueprintValues = response.data.values;
						this.textFieldContent = response.data.values[0].value;
						this.textBlockOptions = response.data.values.map((element, index) => {
							return { display: element.label ? element.label : 'Textblock ' + (index + 1), value: element.id };
						});
						this.selectedTextBlockOption = this.textBlockOptions[0];
						this.isDoneInitializing = true;
					})
					.catch(e => {
						console.log(e);
						this.$swal(this.$t('general.error').toString(), this.$t('values_cannot_be_fetched').toString(), 'error');
					});
			}
		},
		setTextBoxContent($event) {
			const value = this.pdfBlueprintValues.find(element => element.id === $event.value)?.value || '';
			this.textFieldContent = value;
			if (this.editor) this.editor.commands.setContent(value, false);
		},
		fetchDefault() {
			this.$swal({
				title: this.$t('sure').toString(),
				text: this.$t('sure_set_to_default').toString(),
				cancelButtonText: this.$t('general.no').toString(),
				showCancelButton: true,
				confirmButtonText: this.$t('general.yes').toString(),
				icon: 'question',
			}).then(result => {
				if (result.value) {
					new PDFBlueprintRepository()
						.resetBlueprintValues(this.pdfTemplate.id)
						.then(response => {
							this.pdfBlueprintValues = response.data.values;
							this.textFieldContent = response.data.values[0].value;
							this.textBlockOptions = response.data.values.map((element, index) => {
								return { display: element.label ? element.label : 'Textblock ' + (index + 1), value: element.id };
							});
							this.selectedTextBlockOption = this.textBlockOptions[0];
							this.$swal(this.$t('general.success').toString(), this.$t('mask_set_to_default').toString(), 'success');
						})
						.catch(e => {
							console.log(e);
							this.$swal(this.$t('general.error').toString(), this.$t('default_cannot_be_fetched').toString(), 'error');
						});
				}
			});
		},
		save() {
			if (this.$store.getters.getUser.person.company.id === getL2AdminID()) {
				new PDFBlueprintRepository()
					.updateBlueprintSampleValues(this.pdfTemplate.id, this.pdfBlueprintValues)
					.then(response => {
						this.pdfBlueprintValues = response.data.values;
						this.$store.commit('setConfirmLeaving', false);
						this.$swal(this.$t('general.success').toString(), this.$t('pdf_blueprint_saved').toString(), 'success');
					})
					.catch(e => {
						console.log(e);
						this.$swal(this.$t('general.error').toString(), this.$t('general.changes_not_saved').toString(), 'error');
					});
			} else {
				new PDFBlueprintRepository()
					.updateBulkBlueprintValues(this.pdfTemplate.id, this.pdfBlueprintValues)
					.then(response => {
						this.pdfBlueprintValues = response.data.values;
						this.$store.commit('setConfirmLeaving', false);
						this.$swal(this.$t('general.success').toString(), this.$t('pdf_blueprint_saved').toString(), 'success');
					})
					.catch(e => {
						console.log(e);
						this.$swal(this.$t('general.error').toString(), this.$t('general.changes_not_saved').toString(), 'error');
					});
			}
		},
		onBold() {
			if (!this.editor) return;
			this.editor
				.chain()
				.focus()
				.toggleBold()
				.run();
			this.isBold = this.editor.isActive('bold');

			clearTimeout(this.textfieldTimeoutID);
			this.textfieldTimeoutID = setTimeout(() => {
				this.pdfBlueprintValues.find(element => element.id === this.selectedTextBlockOption.value).value = this.textFieldContent;
				this.getPDF();
			}, 1000);
		},
		onItalic() {
			if (!this.editor) return;
			this.editor
				.chain()
				.focus()
				.toggleItalic()
				.run();
			this.isItalic = this.editor.isActive('italic');

			clearTimeout(this.textfieldTimeoutID);
			this.textfieldTimeoutID = setTimeout(() => {
				this.pdfBlueprintValues.find(element => element.id === this.selectedTextBlockOption.value).value = this.textFieldContent;
				this.getPDF();
			}, 1000);
		},
		onUnderline() {
			if (!this.editor) return;
			this.editor
				.chain()
				.focus()
				.toggleUnderline()
				.run();
			this.isUnderlined = this.editor.isActive('underline');

			clearTimeout(this.textfieldTimeoutID);
			this.textfieldTimeoutID = setTimeout(() => {
				this.pdfBlueprintValues.find(element => element.id === this.selectedTextBlockOption.value).value = this.textFieldContent;
				this.getPDF();
			}, 1000);
		},
		applyFontSize() {
			//todo: replace with new editor
			if (!this.engine || !this.selectedFontSize) return;
			this.engine.setFontSize(this.selectedFontSize.value);
		},
		focusEnd() {
			if (!this.editor) return;
			this.editor
				.chain()
				.focus('end')
				.run();
		},
		initEngineOnce() {
			if (this.engine) return; // already initialized

			this.$nextTick(() => {
				const el = this.$refs.ed;
				if (!el) {
					// editor not in DOM yet; try again on next microtask
					setTimeout(this.initEngineOnce, 0);
					return;
				}
				try {
					this.engine = new EditorEngine(el, html => {
						this.textFieldContent = html; // engine -> v-model
						// turn on logging:
					});
					// if we already have content, render it
					if (this.textFieldContent) this.engine.setHtml(this.textFieldContent);
					this.engine.debug = true;
				} catch (e) {
					this.engine = null;
				}
			});
		},
		getPDF() {
			this.isPDFLoading = true;
			this.pdfURL = '';

			PdfApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.pdfDamagecasesTypeTempSavePost(PDFTypes.DamageAccessor, {
					blueprintValues: this.pdfBlueprintValues,
					isForTemp: true,
					damageAssessorCompany: { id: this.$store.getters.getUser.person.company.companyable.id },
				})
				.then(res => {
					this.uuid = res.data.uuid;
					this.isPDFLoading = false;
					//	this.pdfURL = apiDefaults.axios.defaults.baseURL + 'api/pdf/damagecases/' + res.data.uuid + '/temp/file#toolbar=0&navpanes=0&scrollbar=0';
				});
		},
		getData() {
			return this.pdfBlueprintValues;
		},
	},
};
</script>

<style scoped>
::v-deep .ProseMirror {
	padding: 12px;
	outline: none;
	min-height: 100%;
	white-space: pre-wrap;
	word-break: break-word;
}

.editor-surface:focus {
	outline: none;
}

::v-deep .scroll-container::-webkit-scrollbar {
	width: 0;
	height: 0;
}

::v-deep .scroll-container {
	scrollbar-width: none;
}

::v-deep .scroll-container {
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
}
</style>
